/*eslint-disable*/ export const messages = {
    "Go to the first page": "Go to the first page",
    "Go to the last page": "Go to the last page",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Pagination, showing ",
        ["from"],
        " through ",
        ["to"],
        " of ",
        ["total"],
        " entities",
    ],
    "Show next {entitiesPerPage} entities": ["Show next ", ["entitiesPerPage"], " entities"],
    "Show previous {entitiesPerPage} entities": ["Show previous ", ["entitiesPerPage"], " entities"],
    "{from} through {to} of {total}": [["from"], " through ", ["to"], " of ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " of ", ["total"]],
};
